import { Box, Flex } from '@chakra-ui/react'
import { FC } from 'react'
import { Link, useLocation } from 'react-router-dom'
import ColorModeSwitcher from './ColorModeSwitcher'
import Logo from './Logo'

const Page: FC = ({ children }) => {
  const location = useLocation()
  return (
    <Box
      minH="100vh"
      maxW="1280px"
      mx="auto"
      px={8}
      sx={{
        'a:hover': {
          textDecoration: 'underline',
        },
      }}
    >
      <header>
        <Flex py={6} mb={12} alignItems="center">
          <Link to="/">
            <Logo style={{ width: '6rem', height: 'auto' }} />
          </Link>
          {location.pathname !== '/' ? (
            <Link to="/" style={{ marginLeft: '2rem' }}>
              Dashboard
            </Link>
          ) : null}
          <ColorModeSwitcher ml="auto" opacity={0.5} />
        </Flex>
      </header>
      <main style={{ paddingBottom: '2rem' }}>{children}</main>
    </Box>
  )
}

export default Page
